import Swal from "sweetalert2";
import ReactDOM from "react-dom";
import Loader from "../Components/Loader";
import { Fragment } from "react";

var url_json = require("../location.json");

if (window.location.origin.includes("localhost")) {
  url_json = url_json.local;
} else {
  url_json = url_json.production;
}

const Baners = {
  agregarBaner: async (data) => {
    ReactDOM.render(
      <div className="loader_padre">
        <Loader />
      </div>,
      document.getElementById("loader_padre")
    );

    let url = url_json + "/baner";
    let body = {
      titulo: data.titulo,
      tipo: data.tipo,
    };
    let request = {
      method: "POST",
      body: JSON.stringify(body),
      headers: {
        "Content-type": "application/json; charset=UTF-8",
      },
    };

    let response = await fetch(url, request);
    let res = await response.json();

    ReactDOM.render(
      <Fragment></Fragment>,
      document.getElementById("loader_padre")
    );

    if (response.ok) {
      Swal.fire(
        "Inserción exitosa!",
        "Baner agregado correctamente",
        "success"
      ).then(() => {
        window.location.reload();
      });
    } else {
      Swal.fire(
        "Error!",
        "No se pudo guardar el baner, codigo: " + res.message,
        "error"
      );
    }
    return { success: response.ok, data: res.data, code: res.message };
  },
  obtenerBaners: async () => {
    let url = url_json + "/baner";
    let request = {
      method: "GET",
      headers: {
        "Content-type": "application/json; charset=UTF-8",
      },
    };

    let response = await fetch(url, request);
    let json = await response.json();
    return { success: response.ok, data: json.data, code: json.message };
  },
  obtenerConfiguracionBaners: async () => {
    let url = url_json + "/baner/configuracion";
    let request = {
      method: "GET",
      headers: {
        "Content-type": "application/json; charset=UTF-8",
      },
    };

    let response = await fetch(url, request);
    let json = await response.json();
    return { success: response.ok, data: json.data, code: json.message };
  },
  obtenerUnaBaner: async (id) => {
    let url = url_json + "/baner/" + id;
    let request = {
      method: "GET",
      headers: {
        "Content-type": "application/json; charset=UTF-8",
      },
    };

    let response = await fetch(url, request);
    let json = await response.json();
    return { success: response.ok, data: json.data, code: json.message };
  },
  editarBaner: async (data, id) => {
    Swal.fire({
      icon: "question",
      title: "¿Esta seguro que desea modificar el baner?",
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "Si",
      denyButtonText: `No`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        ReactDOM.render(
          <div className="loader_padre">
            <Loader />
          </div>,
          document.getElementById("loader_padre")
        );

        let url = url_json + "/baner/" + id;

        let body = {
          titulo: data.titulo,
          tipo: data.tipo,
        };
        let request = {
          method: "PATCH",
          body: JSON.stringify(body),
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };

        let response = await fetch(url, request);
        let res = await response.json();

        ReactDOM.render(
          <Fragment></Fragment>,
          document.getElementById("loader_padre")
        );

        if (response.ok) {
          Swal.fire(
            "Modificación exitosa!",
            "Baner modificado correctamente",
            "success"
          ).then(() => {
            window.location.reload();
          });
        } else {
          Swal.fire("Error!", "No se pudo modificar el baner", "error").then(
            () => {
              window.location.reload();
            }
          );
        }
      } else if (result.isDenied) {
        Swal.fire("Modificación cancelada", "El campo quedo intacto", "succes");
      }
    });
  },
  editarConfiguracionBaner: async (body) => {
    Swal.fire({
      icon: "question",
      title: "¿Esta seguro que desea modificar la configuracion de los baners?",
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "Si",
      denyButtonText: `No`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        ReactDOM.render(
          <div className="loader_padre">
            <Loader />
          </div>,
          document.getElementById("loader_padre")
        );

        let url = url_json + "/baner/configuracion";

        let request = {
          method: "PATCH",
          body: JSON.stringify(body),
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };

        let response = await fetch(url, request);
        let res = await response.json();

        ReactDOM.render(
          <Fragment></Fragment>,
          document.getElementById("loader_padre")
        );

        if (response.ok) {
          Swal.fire(
            "Modificación exitosa!",
            "Configuracion actualizada correctamente",
            "success"
          ).then(() => {
            window.location.reload();
          });
        } else {
          Swal.fire(
            "Error!",
            "No se pudo actualizar la configuracion",
            "error"
          ).then(() => {
            window.location.reload();
          });
        }
      } else if (result.isDenied) {
        Swal.fire("Modificación cancelada", "El campo quedo intacto", "succes");
      }
    });
  },
  eliminarBaner: async (id) => {
    Swal.fire({
      icon: "question",
      title: "¿Esta seguro que desea eliminar el baner?",
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "Si",
      denyButtonText: `No`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        ReactDOM.render(
          <div className="loader_padre">
            <Loader />
          </div>,
          document.getElementById("loader_padre")
        );

        let url = url_json + "/baner/delete/" + id;
        let request = {
          method: "PATCH",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };

        let response = await fetch(url, request);
        let res = await response.json();

        ReactDOM.render(
          <Fragment></Fragment>,
          document.getElementById("loader_padre")
        );

        if (response.ok) {
          Swal.fire(
            "Eliminación exitosa!",
            "Baner eliminado correctamente",
            "success"
          ).then(() => {
            window.location.reload();
          });
        } else {
          Swal.fire("Error!", "No se pudo eliminar el baner", "error");
        }
        return { success: response.ok, data: res.data };
      } else if (result.isDenied) {
        Swal.fire("Eliminación cancelada", "El campo quedo intacto", "succes");
      }
    });
  },
};

export default Baners;
